import React from 'react';
import { LayoutDashboardIcon, InfoIcon, BarChartIcon, PackageIcon, FileTextIcon, UploadIcon } from 'lucide-react';
type Step = {
  id: number;
  name: string;
  component: React.ReactNode;
};
interface SidebarProps {
  steps: Step[];
  currentStep: number;
  setCurrentStep: (step: number) => void;
}
export function Sidebar({
  steps,
  currentStep,
  setCurrentStep
}: SidebarProps) {
  const icons = [<InfoIcon size={20} data-id="element-238" />, <BarChartIcon size={20} data-id="element-239" />, <PackageIcon size={20} data-id="element-240" />, <FileTextIcon size={20} data-id="element-241" />, <UploadIcon size={20} data-id="element-242" />, <LayoutDashboardIcon size={20} data-id="element-243" />];
  return <aside className="w-64 bg-white border-r border-gray-200 hidden md:block" data-id="element-244">
      <nav className="mt-8 px-4" data-id="element-245">
        <ul className="space-y-2" data-id="element-246">
          {steps.map((step, index) => <li key={step.id} data-id="element-247">
              <button onClick={() => setCurrentStep(index)} className={`flex items-center w-full px-4 py-3 text-left rounded-lg hover:bg-gray-100 ${currentStep === index ? 'bg-blue-50 text-blue-700' : 'text-gray-700'}`} data-id="element-248">
                <span className="mr-3" data-id="element-249">{icons[index]}</span>
                <span className="font-medium" data-id="element-250">{step.name}</span>
              </button>
            </li>)}
        </ul>
      </nav>
    </aside>;
}